import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import './DesignSystem.css'
import './index.css'
import App from './App.jsx'
import db from './services/db'
import { buildSiteVisitPayload } from './utils/siteVisitTracker'
import { ensureServiceWorker } from './utils/webPushClient'

const bootstrapVisit = buildSiteVisitPayload(window.location.pathname, window.location.search)
if (bootstrapVisit) {
    db.logSiteVisit(bootstrapVisit).catch(() => {})
}

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    ensureServiceWorker().catch(() => {})
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
